import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import translationFR from './locales/fr.json';
import translationAR from './locales/ar.json';
import translationDE from "./locales/de.json"; // 👈 NEU

const resources = {
  fr: { translation: translationFR },
  ar: { translation: translationAR },
  de: { translation: translationDE }, // 👈 NEU
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    supportedLngs: ["fr", "de", "ar"],      // 👈 explizit whitelisten
    fallbackLng: "fr",
    // ❗ KEIN festes 'lng': so greift die Detection (Query, LocalStorage, Browser)
    load: "languageOnly",
    interpolation: { escapeValue: false },
    returnEmptyString: false,
    detection: {
      // 👇 Query-Param zuerst, dann Persistenz, dann Browser & <html>
      order: ["querystring", "localStorage", "navigator", "htmlTag", "cookie"],
      lookupQuerystring: "lang",
      caches: ["localStorage"],
    },
    react: { useSuspense: false },
  });

export default i18n;